import React from 'react';
import { booksData } from '../data/booksData';
import { FaEbay, FaGoodreads } from 'react-icons/fa';
import { AiFillAmazonCircle } from 'react-icons/ai';

function Books() {
  return (
    <div className="covers-box">
      <div className="covers-box__bigger">
        {booksData.map((val, index) => (
          <div className="covers-box__cell-description" key={index}>
            <img
              src={val.image}
              alt="book cover"
              className="book-cover u-margin-bottom-m"
            />

            <div className="covers-box__description u-margin-bottom-m">
              <h4 className="heading-4 text-transformed-s u-margin-bottom-s">
                {val.author}
              </h4>
              <p className="paragraph-s paragraph-bold">{val.title}</p>
            </div>

            <div className="covers-box__shop">
              <AiFillAmazonCircle className="icon icon__login icon__shop" />
              <FaEbay className="icon icon__login icon__shop" />
              <FaGoodreads className="icon icon__login icon__shop" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Books;
